/**
 * Prescription PropTypes
 *
 * PropType definitions for prescription forms, validation, and eye measurement data.
 * Used in frame customization and prescription input workflows.
 *
 * @module propTypes/prescription
 */

import PropTypes from "prop-types";

/**
 * Eye prescription data shape
 * Represents prescription values for a single eye
 *
 * @property {string} sph - Sphere (SPH) value
 * @property {string} cyl - Cylinder (CYL) value
 * @property {string} axis - Axis value
 */
export const eyePrescriptionShape = PropTypes.shape({
  sph: PropTypes.string,
  cyl: PropTypes.string,
  axis: PropTypes.string,
});

/**
 * Complete prescription form data shape
 * Contains prescription data for both eyes and pupillary distance
 *
 * @property {Object} rightEye - Right eye prescription values
 * @property {Object} leftEye - Left eye prescription values
 * @property {string} pd - Pupillary distance (PD) measurement
 */
export const prescriptionFormDataShape = PropTypes.shape({
  rightEye: eyePrescriptionShape,
  leftEye: eyePrescriptionShape,
  pd: PropTypes.string,
});

/**
 * Prescription field configuration shape
 * Defines field properties for prescription input forms
 *
 * @property {string} label - Field label
 * @property {string} placeholder - Placeholder text
 */
export const prescriptionFieldConfigShape = PropTypes.shape({
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
});

/**
 * Prescription validation errors shape
 * Maps field keys to error messages
 */
export const prescriptionValidationErrorsShape = PropTypes.object;
